import React, { useState, useEffect, useRef } from "react";
import AdminAppBar from "../../adminComponents/AdminAppBar";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import propertyService from "../../Services/PropertyService";
import { getIcons } from "../../Constant/Constant";
import { showErrorToast, showSuccessToast } from "../../Constant/Notification";
import Loader from "../../Constant/Loader";
import NotFound from "../../Form/NotFound/NotFound";
import EstimateGeneration from "./EstimateGeneration";
import EstimateHistoryModel from "./EstimateHistoryModel";

const PropertyMain = () => {
  const icons = getIcons();
  const navigate = useNavigate();
  const categoriesRef = useRef([]);
  const [underlineStyle, setUnderlineStyle] = useState({});
  const [properties, setProperties] = useState([]);
  const [importType, setImportType] = useState(false);
  const [filteredProperties, setFilteredProperties] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenModel, setIsOpenModel] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [selectedPropertyType, setSelectedPropertyType] =
    useState("All Properties");
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const dropdownMenuRef = useRef(null);
  const location = useLocation();
  const userObj = JSON.parse(localStorage.getItem("userData"));
  const userRole = userObj?.user?.role;
  const handleOpen = () => {
    if (userRole === "Admin") {
      navigate("/admin/add-property");
    } else if (userRole === "CMO") {
      navigate("/cmo/add-property");
    }
  };

  const handleDropDownMenu = () => {
    setImportType(!importType);
  };

  const handleestimateModel = () => {
    setIsOpenModel(true);
  };

  useEffect(() => {
    if (location.state?.message) {
      showSuccessToast(location.state.message);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);
  const fetchProperties = async () => {
    setLoading(true);
    try {
      const response = await propertyService.fetchProperties();
      const responseData = response?.data?.properties;

      if (!Array.isArray(responseData)) {
        throw new Error("Invalid property data received");
      }

      setProperties(responseData);

      const savedCategory = "All Properties";
      setSelectedPropertyType(savedCategory);

      const filteredList =
        savedCategory === "All Properties"
          ? responseData
          : responseData.filter((prop) => prop.type === savedCategory);

      const filteredResults = filteredList.filter((property) =>
        property?.name?.toLowerCase().includes(searchTerm.toLowerCase())
      );

      setFilteredProperties(filteredResults);
    } catch (error) {
      console.error("Error fetching properties", error);
      showErrorToast(error?.response?.data || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
  
  
    fetchProperties();
  }, []);
  
  

  useEffect(() => {
    const currentCategory = categoriesRef.current.find(
      (cat) => cat.textContent === selectedPropertyType
    );
    if (currentCategory) {
      setUnderlineStyle({
        left: currentCategory.offsetLeft,
        width: currentCategory.clientWidth,
      });
    }
  }, [selectedPropertyType]);

  const handleCategoryChange = async (category) => {
    setSelectedPropertyType(category);

    if(category === "All Properties") {
      fetchProperties();
      return;
    }
    setLoading(true);

    try {
      const response = await propertyService.fetchPropertiesByType(category);
      const filteredList = response.data;

      if (!filteredList || Object.keys(filteredList).length === 0) {
        setProperties([]);
        setFilteredProperties([]);
        showErrorToast("No properties found.");
        return;
      }
      const propertiesArray = Object.values(filteredList).map(
        (property, i) => ({
          ...property,
          id: Object.keys(filteredList)[i],
        })
      );

      const filteredResults = propertiesArray.filter((property) =>
        property.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setProperties(propertiesArray);
      setFilteredProperties(filteredResults);
    } catch (error) {
      setProperties([]);
      setFilteredProperties([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    const filteredResults = properties.filter((property) =>
      property.name.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setFilteredProperties(filteredResults);
  };

  const handleEstimateGeneration = (property) => {
    setIsOpen(true);
    setSelectedProperty(property);
  };

  const handleOpenBulkAdd = () => {
    if (userRole === "Admin") {
      navigate("/admin/add-bulk-property");
    } else if (userRole === "CMO") {
      navigate("/cmo/add-bulk-property");
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    setIsOpenModel(false);
    setSelectedProperty(null);
  };

  console.log("Properties", properties);
  console.log("Filtered Properties", filteredProperties);
  
  return (
    <div className="bg-appGrayBackground pb-10">
      {loading ? <Loader /> : ""}
      <AdminAppBar />
      <ToastContainer />

      <div className="mb-10 px-20 xl:px-6 pt-28 flex justify-between gap-5 items-center">
        <div>
          <h1 className="text-4xl font-semibold whitespace-nowrap">
            Properties{" "}
            <span className="text-3xl ">({filteredProperties.length})</span>
          </h1>
        </div>

        <div className="relative flex w-[700px] 4xl:w-[1600px] 2xl:w-[900px] 3xl:w-[1300px] items-center ">
          <img
            src={icons.searchIcon}
            alt=""
            className="absolute left-4 w-5 h-5"
          />
          <input
            type="text"
            placeholder="Search Property"
            value={searchTerm}
            onChange={handleSearchChange}
            className="setup-search pl-10 pr-4 h-10 border-stone-400 shadow appearance-none border rounded text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>

        <button
          onClick={handleestimateModel}
          className="border-2 border-customGreen rounded-sm p-1 px-5 mt-2 text-lg text-customGreen h-10 text-center whitespace-nowrap"
        >
          Estimate History
        </button>

        <div>
          <button
            ref={dropdownMenuRef}
            onClick={handleDropDownMenu}
            className="border-2 border-customGreen rounded-sm p-1 px-5 mt-2 text-lg text-customGreen h-10 text-center whitespace-nowrap"
          >
            +Create Property
          </button>

          {importType && (
            <div className="absolute z-50 mt-3 bg-white rounded-md shadow-md w-44 py-2">
              <ul className="list-none">
                <li
                  onClick={handleOpen}
                  className="border-b cursor-pointer border-gray-300 py-2 text-center hover:text-[#399E79]"
                >
                  Manual Add
                </li>
                <li
                  onClick={handleOpenBulkAdd}
                  className="cursor-pointer border-gray-300 py-2 text-center hover:text-[#399E79]"
                >
                  Bulk Add
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>

      <div className="list-container bg-white mt-10 rounded-md shadow-md w-12/12 pt-6 mx-20 xl:mx-6">
        <div className="flex mb-8 justify-around border-slate-400 border-t-0 border-b-2 h-10 border-l-0 w-11/12 ml-14 pb-1 relative">
          {[
            "All Properties",
            "Layout",
            "Resale Land",
            "Resale Building",
            "Villa",
            "Apartment",
            "Acres and Cents",
          ].map((category, index) => (
            <h1
              key={category}
              ref={(el) => (categoriesRef.current[index] = el)}
              className={`text-xl cursor-pointer whitespace-nowrap 4xl:text-3xl ${
                selectedPropertyType === category ? "text-green-500" : ""
              }`}
              onClick={() => handleCategoryChange(category)}
            >
              {category}
            </h1>
          ))}
          <span
            className="absolute top-9 h-1 bg-green-500 transition-all duration-300"
            style={underlineStyle}
          />
        </div>
        <div className="w-12/12">
          <div className="list-scroller  overflow-y-auto max-h-[300px] 3xl:max-h-[500px] xl:max-h-[480px] 2xl:max-h-[480px] lg:max-h-[480px] 4xl:max-h-[750px] custom-scrollbar">
            <table className="w-full table-fixed">
              <thead className="bg-white sticky top-0">
                <tr className="border-b whitespace-nowrap">
                  <th className="text-customGreen xl:text-xl text-2xl font-medium 4xl:text-3xl">
                    Property Name
                  </th>
                  <th className="text-customGreen xl:text-xl text-2xl font-medium 4xl:text-3xl">
                    Location
                  </th>
                  <th className="text-customGreen xl:text-xl text-2xl font-medium 4xl:text-3xl">
                    Type
                  </th>
                  <th className="text-customGreen xl:text-xl text-2xl font-medium 4xl:text-3xl">
                    Available Plots
                  </th>
                  <th className="text-customGreen xl:text-xl text-2xl font-medium 4xl:text-3xl">
                    Available Sq.Feet
                  </th>
                  <th className="text-customGreen xl:text-xl text-2xl font-medium 4xl:text-3xl">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredProperties.length > 0 ? (
                  filteredProperties.map((property) => (
                    <tr
                      key={property.id}
                      className="h-14 w-full text-center font-medium border-b"
                    >
                      <td className="px-5 py-5 ">
                        <div className="flex gap-1 items-center">
                          <span className="text-4xl text-customGreen">
                            &bull;
                          </span>
                          <span
                            className="text-start max-w-80 truncate whitespace-nowrap"
                            title={property?.name}
                          >
                            {property?.name}
                          </span>
                        </div>
                      </td>
                      <td className="3xl:text-lg 4xl:text-2xl">
                        {property?.location}
                      </td>
                      <td className="3xl:text-lg 4xl:text-2xl">
                        {property?.type}
                      </td>
                      <td className="3xl:text-lg 4xl:text-2xl">
                        {property?.availablePlots}
                      </td>
                      <td className="3xl:text-lg 4xl:text-2xl">
                        {property?.availableSqft}
                      </td>
                      <td className="3xl:text-lg 4xl:text-2xl flex justify-center items-center gap-2 mt-6">
                        <div
                          className="text-sky-400 cursor-pointer 3xl:text-lg 4xl:text-2xl"
                          onClick={() =>
                            navigate(
                              `${
                                userRole === "Admin" ? "/admin" : "/cmo"
                              }/update-property/${property.id}`
                            )
                          }
                        >
                          Edit
                        </div>

                        <img
                          src={icons.downloadIcon2}
                          onClick={() => handleEstimateGeneration(property.id)}
                          className="cursor-pointer w-10 h-10"
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">
                      <NotFound title={"Property Not Found"} />
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <EstimateGeneration
        isOpen={isOpen}
        onClose={handleClose}
        propertyId={selectedProperty}
      />
      <EstimateHistoryModel isOpen={isOpenModel} onClose={handleClose} />
    </div>
  );
};

export default PropertyMain;
